import { Component, OnInit, Inject } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { TextDialogData } from '@app/shared/models/dialog-data';
import { BaseComponent } from '@app/shared/components/base/base.component';


@Component({
    selector: 'app-info-dialog',
    templateUrl: './info-dialog.component.html',
    styleUrls: ['./info-dialog.component.scss']
})
export class InfoDialogComponent extends BaseComponent implements OnInit {

    constructor(public dialogRef: MatDialogRef<InfoDialogComponent>,
                @Inject(MAT_DIALOG_DATA) public data: TextDialogData) {
        super();
        this._idPrefix = 'info_dialog.';

        if (typeof data.text === 'string') {
            data.text = [data.text];
        }
    }

    public ngOnInit() {
        if (!Array.isArray(this.data.text)) {
            this.data.text = [this.data.text];
        }
    }

    public close(): void {
        this.dialogRef.close(false);
    }
}
